import { SortDirection } from "config/constants"
import Address, { IAddressDto } from "./Address"

export interface IGetCustomersDashboardParams {
    pageNumber?: number | null
    pageSize?: number | null
    customerNameCriteria?: string
    customerNames?: string[] | null
    customerNumbers?: string[] | null
    vatCodes?: string[] | null
    invoiceNumbers?: string[] | null
    orderBy?: CustomersDashboardSortBy | null
    sortDirection?: SortDirection
}

export enum CustomersDashboardSortBy {
    customerName = "customerName",
    customerNumber = "customerNumber",
    vatCode = "vatCode",
    invoiceAddress = "invoiceAddress",
}

export interface IGetCustomersDashboardItemDto {
    customerName: string
    customerNumber: string
    customerBlocked: boolean
    invoiceAddress?: IAddressDto | null
    vatCode?: string | null
}

export default class CustomersDashboardItem {
    customerName: string
    customerNumber: string
    customerBlocked: boolean
    invoiceAddress?: Address
    vatCode?: string

    constructor(dto: IGetCustomersDashboardItemDto) {
        this.customerName = dto.customerName
        this.customerNumber = dto.customerNumber
        this.customerBlocked = dto.customerBlocked
        this.invoiceAddress = dto.invoiceAddress ? new Address(dto.invoiceAddress) : undefined
        this.vatCode = dto.vatCode || undefined
    }
}
